import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class SessionApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/session`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getInfo() {
    return this.baseApiClient.get<unknown>('/info');
  }
}

export const sessionApi = new SessionApi();
